"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInput = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ClickedOutside_1 = tslib_1.__importDefault(require("../../ClickedOutside"));
const Flex_1 = tslib_1.__importDefault(require("../../Elements/Flex"));
const Loading_1 = require("../../Loading");
const Texts_1 = require("../../Texts");
const StyledComponents_1 = require("../StyledComponents");
const Containers_1 = require("./Containers");
const Icons_1 = require("./Icons");
const defaultProps = {
    disabled: false,
};
const initialState = {
    input: '',
    showInput: false,
    showMenu: false,
};
class SelectInput extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = initialState;
        this.inputRef = react_1.default.createRef();
        this.handleInputChange = (event) => {
            const { onInputChange, asyncMode } = this.props;
            if (onInputChange && asyncMode) {
                onInputChange(event.target.value);
            }
            this.setState({ input: event.target.value });
        };
        this.handleClearValue = (event) => {
            event.preventDefault();
            event.stopPropagation();
            const { input } = this.state;
            const { onChange, onInputChange, onClearValue } = this.props;
            if (onClearValue) {
                onClearValue();
            }
            if (onChange) {
                onChange();
            }
            if (input) {
                if (onInputChange) {
                    onInputChange('');
                }
                this.setState({ input: '', showInput: false });
            }
        };
        this.openInput = () => {
            this.setState({ showInput: true }, () => {
                if (this.inputRef.current) {
                    this.inputRef.current.focus();
                }
            });
        };
        this.closeInput = () => {
            this.setState({ showInput: false });
        };
        this.openMenu = () => this.setState({ showMenu: true });
        this.closeMenu = () => this.setState({ showMenu: false });
        this.open = () => {
            const { disabled } = this.props;
            if (!disabled) {
                this.openMenu();
                this.openInput();
            }
        };
        this.close = () => {
            this.closeMenu();
            this.closeInput();
        };
    }
    render() {
        const { label, hint, error, value, loading, onChange, asyncMode, disabled, renderOption, orderOptions, } = this.props;
        const { input, showInput, showMenu } = this.state;
        let options = input && !asyncMode
            ? this.props.options.filter(item => item.label.toLowerCase().includes(input.toLowerCase()))
            : this.props.options;
        if (orderOptions) {
            options = orderOptions(options);
        }
        return (react_1.default.createElement(StyledComponents_1.Container, null,
            label && react_1.default.createElement(Texts_1.LabelText, null, label),
            react_1.default.createElement(Containers_1.SelectContainer, null,
                react_1.default.createElement(Containers_1.ValueContainer, { onClick: this.open, disabled: disabled },
                    react_1.default.createElement(Flex_1.default, { flex: "1", alignItems: "center" },
                        !showInput && value && react_1.default.createElement(Containers_1.Value, { flex: "1" }, value.label),
                        !showInput && !value && react_1.default.createElement(Containers_1.ValuePlaceholder, { flex: "1" }, "Select ..."),
                        showInput && (react_1.default.createElement(StyledComponents_1.Input, { type: "text", onChange: this.handleInputChange, value: input, ref: this.inputRef, placeholder: "Type to search..." }))),
                    react_1.default.createElement(Containers_1.ActionsContainer, { marginLeft: "auto", alignItems: "center" },
                        loading && (react_1.default.createElement(Containers_1.Action, null,
                            react_1.default.createElement(Loading_1.Spinner, { size: 10 }))),
                        value && (react_1.default.createElement(Containers_1.Action, { onClick: this.handleClearValue },
                            react_1.default.createElement(Icons_1.ClearIcon, null))),
                        react_1.default.createElement(Containers_1.Action, null,
                            react_1.default.createElement(Icons_1.ChevronDown, null)))),
                showMenu && (react_1.default.createElement(ClickedOutside_1.default, { shouldHandleClick: showMenu, onClickOutside: this.close }, ({ ref }) => (react_1.default.createElement(Containers_1.OptionsContainer, { ref: ref }, options.length ? (options.map((option, optionIndex) => (react_1.default.createElement(Containers_1.OptionContainer, { key: `${option.value}-${optionIndex}`, onClick: () => {
                        if (onChange) {
                            onChange(option);
                        }
                        this.close();
                    } }, renderOption ? renderOption(option) : option.label)))) : (react_1.default.createElement(Containers_1.NoOption, { onClick: this.close }, "No Option"))))))),
            react_1.default.createElement(Texts_1.HintText, { error: !!error },
                error || hint,
                "\u00A0")));
    }
}
exports.SelectInput = SelectInput;
SelectInput.defaultProps = defaultProps;
